import { render, staticRenderFns } from "./ScratchCardForm.vue?vue&type=template&id=6fb0068a&scoped=true"
import script from "./ScratchCardForm.vue?vue&type=script&lang=js"
export * from "./ScratchCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0068a",
  null
  
)

export default component.exports